const quickLinks = [
  { label: "格式分类", href: "#formats" },
  { label: "热门作品", href: "#trending" },
  { label: "编辑精选", href: "#picks" },
  { label: "主题浏览", href: "#themes" },
  { label: "常见问题", href: "#faq" },
];

const formatLinks = ["漫画本", "插画画集", "四格漫画", "网络条漫", "短篇合集"];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <a href="#home" className="flex items-center gap-2 whitespace-nowrap">
              <span className="grid h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-lg text-primary-950">
                <i className="ri-book-2-fill"></i>
              </span>
              <span className="font-label text-lg tracking-wide text-background-50">同人志典藏站</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-100/80">
              把同人漫画本、插画画集、四格漫画、网络条漫与短篇合集按格式打包，一键整本阅读的在线阅读平台。
              适合喜欢收藏与翻阅同人作品的每一位读者。
            </p>
            <div className="mt-5 flex gap-3">
              <a href="#home" aria-label="微博" className="grid h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-accent-500 hover:text-primary-950">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#home" aria-label="哔哩哔哩" className="grid h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-accent-500 hover:text-primary-950">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
              <a href="#home" aria-label="公众号" className="grid h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-accent-500 hover:text-primary-950">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="mailto:hello@doujinshi.example.com" aria-label="邮箱" className="grid h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-accent-500 hover:text-primary-950">
                <i className="ri-mail-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-label text-sm text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-background-100/80 transition-colors hover:text-accent-300">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-label text-sm text-background-50">内容格式</h3>
            <ul className="mt-4 space-y-2.5">
              {formatLinks.map((f) => (
                <li key={f}>
                  <a href="#formats" className="text-sm text-background-100/80 transition-colors hover:text-accent-300">
                    {f}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/10 pt-6 sm:flex-row">
          <p className="text-xs text-background-100/70">
            © {new Date().getFullYear()} 同人志典藏站 · 为喜欢收藏与翻阅同人作品的读者而建
          </p>
          <a href="#home" className="inline-flex items-center gap-1 text-xs text-background-100/70 transition-colors hover:text-accent-300">
            <i className="ri-arrow-up-line"></i>
            返回顶部
          </a>
        </div>
      </div>
    </footer>
  );
}